import type { IconNode } from '../types';

/**
 * @name cricket-wicket
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJtNiAyIDQgMiIgLz4KICA8cGF0aCBkPSJtMTQgMyA0LTEiIC8+CiAgPGNpcmNsZSBjeD0iMTIiIGN5PSIxMyIgcj0iMiIgLz4KICA8cGF0aCBkPSJNNiA3djE1IiAvPgogIDxwYXRoIGQ9Im0xMyA3LS4zIDQuMSIgLz4KICA8cGF0aCBkPSJNMTIuNSAxNC45IDEyIDIyIiAvPgogIDxwYXRoIGQ9Ik0xOCA3djE1IiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/cricket-wicket
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const cricketWicket: IconNode = [
  ['path', { d: 'm6 2 4 2', key: '1ds25p' }],
  ['path', { d: 'm14 3 4-1', key: 'vejvrd' }],
  ['circle', { cx: '12', cy: '13', r: '2', key: '1c1ljs' }],
  ['path', { d: 'M6 7v15', key: '13f049' }],
  ['path', { d: 'm13 7-.3 4.1', key: '6pztqx' }],
  ['path', { d: 'M12.5 14.9 12 22', key: '10b2on' }],
  ['path', { d: 'M18 7v15', key: '1oaaxh' }],
];

export default cricketWicket;
